module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('progress-bar', {
    attrs: {
      "show": _vm.busy
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "grey lighten-4",
    attrs: {
      "primary-title": ""
    }
  }, [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(_vm.$t('personal_info')))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      },
      "keydown": function($event) {
        return _vm.form.onKeydown($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "pa-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('h3', {
    staticClass: "subheading mb-2"
  }, [_vm._v(_vm._s(_vm.$t('info_name_address')))]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "pa-0": ""
    }
  }, [(_vm.form.is_company == '1') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('name_company'),
      "v-errors": _vm.errors,
      "value": _vm.form.company_name,
      "name": "company_name"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "company_name", $event)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('company_org_no'),
      "v-errors": _vm.errors,
      "value": _vm.form.company_org_no,
      "name": "company_org_no",
      "solo": ""
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "company_org_no", $event)
      }
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('name_first'),
      "v-errors": _vm.errors,
      "value": _vm.form.name_first,
      "name": "name_first"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "name_first", $event)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('name_last'),
      "v-errors": _vm.errors,
      "value": _vm.form.name_last,
      "name": "name_last",
      "solo": ""
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "name_last", $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.form.is_company != '1') ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "pa-0": "",
      "pb-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": ""
    }
  }, [_c('v-select', {
    class: {
      danger: _vm.errors.has('form.birth_year')
    },
    attrs: {
      "items": _vm.years,
      "label": _vm.$t('birth_year'),
      "name": "birth_year",
      "rules": [function (v) { return !!v || 'The Birth year field is required.'; }],
      "required": "",
      "box": ""
    },
    model: {
      value: (_vm.form.birth_year),
      callback: function($$v) {
        _vm.$set(_vm.form, "birth_year", $$v)
      },
      expression: "form.birth_year"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('email-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('email'),
      "v-errors": _vm.errors,
      "value": _vm.form.email,
      "name": "email",
      "box": ""
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "email", $event)
      }
    }
  }), _vm._v(" "), _c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('phone'),
      "v-errors": _vm.errors,
      "value": _vm.form.phone,
      "name": "phone"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "phone", $event)
      }
    }
  }), _vm._v(" "), _c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('address_street_1'),
      "v-errors": _vm.errors,
      "value": _vm.form.address_street_1,
      "name": "address_street_1"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "address_street_1", $event)
      }
    }
  }), _vm._v(" "), _c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('address_street_2'),
      "v-errors": _vm.errors,
      "value": _vm.form.address_street_2,
      "name": "address_street_2"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "address_street_2", $event)
      }
    }
  }), _vm._v(" "), _c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('address_zip'),
      "v-errors": _vm.errors,
      "value": _vm.form.address_zip,
      "name": "address_zip"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "address_zip", $event)
      }
    }
  }), _vm._v(" "), _c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('address_city'),
      "v-errors": _vm.errors,
      "value": _vm.form.address_city,
      "name": "address_city"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "address_city", $event)
      }
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    class: 'pb-2',
    attrs: {
      "items": _vm.countries,
      "item-text": "country_name",
      "item-value": "iso",
      "box": "",
      "label": "Country",
      "placeholder": "Start typing to Search",
      "autocomplete": "no",
      "browser-autocomplete": "",
      "name": "address_country",
      "rules": [function (v) { return !!v || 'The Country field is required'; }],
      "required": ""
    },
    model: {
      value: (_vm.form.address_country),
      callback: function($$v) {
        _vm.$set(_vm.form, "address_country", $$v)
      },
      expression: "form.address_country"
    }
  }), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.invoice_currencies,
      "label": _vm.$t('invoice_currency'),
      "box": ""
    },
    model: {
      value: (_vm.form.invoice_currency),
      callback: function($$v) {
        _vm.$set(_vm.form, "invoice_currency", $$v)
      },
      expression: "form.invoice_currency"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pt-0": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [(_vm.form.is_company != '1') ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('h3', {
    staticClass: "subheading mb-2",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('info_skills')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: (_vm.skills_dialog),
      callback: function($$v) {
        _vm.skills_dialog = $$v
      },
      expression: "skills_dialog"
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "color": "primary",
      "flat": "",
      "small": ""
    },
    slot: "activator"
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("help_outline")]), _vm._v("\n                        Skills\n                      ")]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                          Skills levels\n                        ")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v("Fitness")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("I don’t exercise regularly and ski for less than two weeks a year. I can walk (on skis with skins) for an hour without any difficulties.")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("I exercise once or twice a week and ski for two to four weeks a year. I can walk (on skis with skins) for two hours without any difficulties.")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("I exercise regularly and ski at least one month a year. I can walk (on skis with skins) for half a day without any difficulties.")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("I exercise frequently and go skiing as often as I can. I can walk uphill and/or ski down for a whole day.")])])])]), _vm._v(" "), _c('h3', [_vm._v("Technical")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("A")]), _vm._v(" "), _c('td', [_vm._v("I can ski red pistes. I have little off-piste experience but dream of powder skiing… Discovering ski touring and going uphill on skis with skins is something I would like to try out.")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("B")]), _vm._v(" "), _c('td', [_vm._v("I can ski all types of pistes. I sometimes ski off-piste but would like to improve my skills. Ski touring interests me.")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("C")]), _vm._v(" "), _c('td', [_vm._v("I can ski all types of piste including off-piste as long as the terrain isn’t too steep. I have already gone ski touring and would like to refine my technique, knowledge of the mountains and about the equipment that is required.")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("D")]), _vm._v(" "), _c('td', [_vm._v(" I am a very competent skier and can easily ski anywhere, whether on-piste or off-piste. I go ski touring regularly.")])])])])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.skills_dialog = false
      }
    }
  }, [_vm._v("\n                            Close\n                          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    class: {
      danger: _vm.errors.has('form.level_fitness')
    },
    attrs: {
      "items": _vm.skills_fitness,
      "label": _vm.$t('skills_fitness'),
      "name": "level_fitness",
      "rules": [function (v) { return !!v || 'Fitness level is required'; }],
      "required": "",
      "box": ""
    },
    model: {
      value: (_vm.form.level_fitness),
      callback: function($$v) {
        _vm.$set(_vm.form, "level_fitness", $$v)
      },
      expression: "form.level_fitness"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    class: {
      danger: _vm.errors.has('form.skills_technical')
    },
    attrs: {
      "items": _vm.skills_technical,
      "label": _vm.$t('skills_technical'),
      "name": "skills_technical",
      "rules": [function (v) { return !!v || 'Technical skills is required'; }],
      "required": "",
      "box": ""
    },
    model: {
      value: (_vm.form.level_technical),
      callback: function($$v) {
        _vm.$set(_vm.form, "level_technical", $$v)
      },
      expression: "form.level_technical"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "box": "",
      "name": "skills_comment",
      "label": _vm.$t('skills_comment')
    },
    model: {
      value: (_vm.form.skills_comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "skills_comment", $$v)
      },
      expression: "form.skills_comment"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "subheading mb-2"
  }, [_vm._v(_vm._s(_vm.$t('info_physical')))]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": "",
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.shoe_size,
      "label": _vm.$t('shoe_size'),
      "box": ""
    },
    model: {
      value: (_vm.form.shoe_size),
      callback: function($$v) {
        _vm.$set(_vm.form, "shoe_size", $$v)
      },
      expression: "form.shoe_size"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('weight'),
      "v-errors": _vm.errors,
      "value": _vm.form.weight,
      "name": "weight"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "weight", $event)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('height'),
      "v-errors": _vm.errors,
      "value": _vm.form.height,
      "name": "height"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "height", $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "box": "",
      "name": "food_medical_comment",
      "label": _vm.$t('food_medical_comment')
    },
    model: {
      value: (_vm.form.food_medical_comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "food_medical_comment", $$v)
      },
      expression: "form.food_medical_comment"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "subheading mb-2"
  }, [_vm._v(_vm._s(_vm.$t('info_insurance')))]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": "",
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('insurance_company'),
      "v-errors": _vm.errors,
      "value": _vm.form.insurance_company,
      "name": "insurance company"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "insurance_company", $event)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('insurance_number'),
      "v-errors": _vm.errors,
      "value": _vm.form.insurance_number,
      "name": "insurance number"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "insurance_number", $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h3', {
    staticClass: "subheading mb-2"
  }, [_vm._v(_vm._s(_vm.$t('emergency_contact')))]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('name_first'),
      "v-errors": _vm.errors,
      "value": _vm.form.ice_name_first,
      "name": "ice_name_first"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "ice_name_first", $event)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('name_last'),
      "v-errors": _vm.errors,
      "value": _vm.form.ice_name_last,
      "name": "ice_name_last",
      "solo": ""
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "ice_name_last", $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('text-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "form": _vm.form,
      "label": _vm.$t('phone'),
      "v-errors": _vm.errors,
      "value": _vm.form.ice_phone,
      "name": "ice_phone"
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.form, "ice_phone", $event)
      }
    }
  })], 1) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('submit-button', {
    attrs: {
      "flat": false,
      "color": 'primary',
      "form": _vm.form,
      "label": _vm.$t('save')
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92eb35c4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile.vue
// module id = acK0
// module chunks = 1